import { createLazyFileRoute } from "@tanstack/react-router";

import { EditProviderPage } from "@/features/admin/routes/AuthProviderEdit";

export const Route = createLazyFileRoute(
  "/_auth/admin/auth/providers/$id/edit",
)({
  component: () => {
    const params = Route.useParams();
    return <EditProviderPage {...params} />;
  },
});
